export const getFromSelectionFactory = (selections, isSelectMany = false) => {
  if (Array.isArray(selections)) {
    if (selections) {
      var selection = selections.filter(function (element) {
        return element.selected === true
      })
      if (isSelectMany) {
        return selection
      }
      return selection[0]?.value ?? undefined
    }
  } else if (typeof selections === "string" && selections) {
    return selections
  }
  return undefined
}
